import { Injectable, Injector, inject } from '@angular/core';
import {
  HttpContextToken,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { EdsNotificationService, NotificationStatus } from '@eventim/eds2/notification';
import { TranslateService } from '@ngx-translate/core';

export const ERROR_MESSAGES = new HttpContextToken<Record<number, string>>(() => ({}));

@Injectable()
export class ApiErrorInterceptor implements HttpInterceptor {
  private readonly notificationService = inject(EdsNotificationService);
  private readonly injector = inject(Injector);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      catchError((err: unknown) => {
        if (err instanceof HttpErrorResponse) {
          const message = this.buildMessage(err, req.context.get(ERROR_MESSAGES));
          this.notificationService.createSnackBar({
            message,
            status: NotificationStatus.alert,
            duration: 5000,
          });
        }
        return throwError(() => err);
      }),
    );
  }

  private buildMessage(err: HttpErrorResponse, overrides: Record<number, string>): string {
    const translate = this.injector.get(TranslateService);

    if (overrides[err.status]) {
      return translate.instant(overrides[err.status]);
    }

    const apiMsg =
      (typeof err.error === 'string' && err.error) ||
      err.error?.message ||
      err.error?.error ||
      err.message;

    switch (err.status) {
      case 400:
        return translate.instant('error.badRequest');
      case 401:
        return translate.instant('error.unauthorized');
      case 403:
        return translate.instant('error.forbidden');
      case 404:
        return translate.instant('error.notFound');
      case 409:
        return translate.instant('error.conflict');
      case 500:
        return translate.instant('error.server');
      default:
        return apiMsg || `Erreur HTTP (${err.status}).`;
    }
  }
}
